import { AnalyticsService } from '../analytics/analytics.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, User } from '../user/auth.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { Urls } from '../unsplash/unsplash.response';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Registry } from '../registry/registry';
import { Gift } from '../gift/gift';
import { DatepickerOptions } from 'ng2-datepicker';
import * as en from 'date-fns/locale/en';
import { ThrowStmt } from '@angular/compiler';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
@Component({
  selector: 'app-welcome-popup',
  templateUrl: './reg-intro-popup.component.html',
  styleUrls: ['./reg-intro-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class RegIntroPopupComponent implements OnInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  hide: boolean;
  user: User;
  noDate = false;
  registry: Registry;  
  settings: Settings;
    creatingGifts = false;
    showTranslation = false;
  @Output() headerPopupEvent: EventEmitter<any>;
  public textHope = 'In these uncertain times, our love shines the brightest. Whether far or near, we can\'t wait to set off on our adventure of a lifetime together.';
  public textWarm = 'Your presence is present enough, but for those who wish to contribute, please choose a gift from our honeymoon registry.';
  public textModern = 'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
  public textGrateFul = 'Your love, laughter, and company on our big day is the greatest gift of all. However, should you wish to help us celebrate with a gift, please choose from our honeymoon registry.';
  public textHumbled = 'We\'re humbled to have you join us on our special day, and your presence is truly present enough. However, if you feel so obliged to give a gift, please choose from our honeymoon registry.';
  public textFormal = 'As we\'re already lucky enough to have all the physical items we need to start our lives together, we\'ve created a honeymoon registry so we can create new experiences that will last a lifetime.';
  public textPoem = 'If choosing a gift is not your cup of tea, you might like to try our honeymoon registry. Please feel no obligation to use this list, as we do not mind if you decide to give it a miss.';
  options: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date'
    // placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  weddingDay: string;
  date: Date;
  regOriginalDate: Date;
  weddingMonth: string;
  years: Array<number>;
  days: Array<number>;


  @Input() showPopup = false;
  anonymousMode: boolean;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _settingsStateStore: SettingsStateStore

  ) {

    
    this._registryService.showGenericPopup$.subscribe(popupType => {

      if (popupType == "couple/reg-intro"){
      this.showPopup = true;

      ;
      // if(!this.registry && location.pathname.includes('your-registry')){
      //   this.registry = this._registryFirebaseService.getAnonRegistry();
      // }
      this.anonymousMode = this._registryFirebaseService.isAnonRegPath()
      if(this.anonymousMode){
        this.registry = this._registryFirebaseService.getAnonRegistry();
      }
      const body = document.getElementsByTagName('body')[0];    
      body.style.overflow = 'hidden';
      } else {
        this.close();
      }
  
    });

  }

  setViewedIntro(){
    if(this.registry && !this.registry.viewedIntro){
      this.registry.viewedIntro = true;
      this.updateReg(false);
    }
    return;
  }
  datePicked() {
    if (this.date !== this.regOriginalDate) {
      this.registry.weddingDay = this.date.getDate();
      this.registry.weddingMonth = this.date.getMonth() + 1;
      this.registry.weddingYear = this.date.getFullYear();
      
    }
  }

  

  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }



  }

  onCheckled(checked: boolean) {
    if (checked) {
      this.noDate = true;
      this.date = null;
   this.registry.weddingDay = null;
   this.registry.weddingMonth= null;
   this.registry.weddingYear = null;
    } else {
      this.noDate = false;
      this.date = new Date();
      this.date.setMonth(this.date.getMonth() + 6);
      this.datePicked();
    }

  }




loadDate(){
  if (
    this.registry&& this.registry.weddingDay &&
    this.registry.weddingMonth &&
    this.registry.weddingYear
  ) {
    this.date = new Date(
      this.registry.weddingYear,
      this.registry.weddingMonth - 1,
      this.registry.weddingDay
    );
    this.regOriginalDate = this.date;
  }
  this.checkDateToggle(this.registry);
}
  createDefaultGifts() {

  }

  checkDateToggle(registry:Registry){

    if(registry && (registry.weddingDay == null || !registry.weddingDay)){
      this.noDate = true;
    } else {
      this.noDate = false;
    }

  }

  ngOnInit() {

    this.user = this.route.snapshot.data.user;
   if (!this.registry){
    this.registry = this.route.snapshot.data.registry;
    this.settings = this.route.snapshot.data.settings;
    if(!this.registry && location.pathname.includes('your-registry')){
      this.registry = this._registryFirebaseService.getAnonRegistry();
    }

    this._settingsStateStore.getState().subscribe(state => {
      
      this.settings = state.settings;
      if(this.registry && this.settings && this.settings.secondLanguage){
      this.registry.translationLanguage = this.settings.secondLanguage;
      }
    })


    this.loadDate()
    this._registryFirebaseService.currentRegistry.subscribe(registry => {
      if (registry) {
        this.registry = registry;    

        if (this.registry.translationLanguage || (this.settings && this.settings.secondLanguage && this.settings.enableTranslations))    {
          this.showTranslation = true;
          
          if(this.settings && this.settings.secondLanguage){
            this.registry.translationLanguage = this.settings.secondLanguage;
            this.showTranslation = true;
          }
        }

        this.loadDate()
      }
    });
   }

   

  }
  

  enableTranslation(){
    this.showTranslation = true;
    this.registry.translationLanguage='English';
    if(  ! this.registry.introductionTextTranslation){
    this.registry.introductionTextTranslation = '';
    }
  }
  updateReg(skipClose = false) {

    if(this.registry){
    this.registry.hasUpdatedRegistry = true;
    }
    if(this._registryFirebaseService.isAnonRegPath()){
      this._registryFirebaseService.saveAnonRegistry(this.registry)
      if(!skipClose){
        this.close();
        }
      return;
     }

    this._registryFirebaseService.updateRegistry(JSON.stringify(this.registry), this.user, this.registry).then(()=>{
      if(!skipClose){
        this.close();
        }
    })
    
  }
  updateUser(): Promise<any> {
    this.user.dismissCreatePopup = true;
    return this._registryFirebaseService.updateUser(this.user);

  }


  giftAssistant() {
    this.updateUser().then(() => {

        this.router.navigate(['/registry/gift-assistant']);

    });

  }


  createGift() {
    this.updateUser().then(() => {

        this.router.navigate(['/registry/create-gift']);

    });

  }

  setCurrency() {
    switch (this.registry.country) {
      
      case 'AU': {
        this.registry.currency = 'AUD';
    
        break;
      }
      case 'US': {
        this.registry.currency = 'USD';
   
        break;
      }
      case 'GB': {
        this.registry.currency = 'GBP';
      
        break;
      }
      case 'DK': {
          this.registry.currency  ='DKK';
        break;
      }
      case 'NZ': {
          this.registry.currency  ='NZD';
        break;
      }

      case 'JP': {
          this.registry.currency  ='JPY';
        break;
      }

      case 'CA': {
          this.registry.currency  ='CAD';
        break;
      }
      case 'AT': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'BE': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'DE': {
        this.registry.currency  ='EUR';
      break;
    }
      case 'EE': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'FI': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'FR': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'DE': {
          this.registry.currency  ='DKK';
        break;
      }
      case 'GR': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'IE': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'IT': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'LV': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'LT': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'LU': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'NL': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'PT': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'SK': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'SI': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'ES': {
          this.registry.currency  ='EUR';
        break;
      }
      case 'SG': {
          this.registry.currency  ='SGD';
        break;
      }
      case 'SG': {
          this.registry.currency  ='USD';
        break;
      }
      case 'HK': {
          this.registry.currency  ='HKD';
        break;
      }

      case 'SE': {
          this.registry.currency  ='SEK';
        break;
      }
      case 'CH': {
          this.registry.currency  ='CHF';
        break;
      }
      case 'NO': {
          this.registry.currency  ='NOK';
        break;
      }
      case 'JP': {
          this.registry.currency  ='EUR';
        break;
      }
      default: {
        this.registry.currency  ='EUR';
      }
      // case 'MX': {
      //     this.registry.currency  ='MXN';
      //   break;
      // }
    }
  }

  openPreview() {
    this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
  }



  close() {
    // this.showPopup = false;
    // this.router.navigate(['registry']);
    // const body = document.getElementsByTagName('body')[0];
    // body.style.overflow = 'auto';


    
    if(!this.showPopup) {
      return;
    }

    this.updateReg(true);
    this.setViewedIntro();
    this.showPopup = false;    
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
        this._registryService.emitHeaderPopupClosed();

  }

}



// WEBPACK FOOTER //
// ./src/app/reg-intro-popup/reg-intro-popup.component.ts